export default __webpack_public_path__ + "static/media/pin-slash-svgrepo-com.a2e849bc.svg";